import { render, staticRenderFns } from "./FotosMonitoramento.vue?vue&type=template&id=107b35fc&scoped=true"
import script from "./FotosMonitoramento.vue?vue&type=script&lang=js"
export * from "./FotosMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./FotosMonitoramento.vue?vue&type=style&index=0&id=107b35fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b35fc",
  null
  
)

export default component.exports